import i18n from '../i18n/i18n';

import CustomError from '../error/CustomError';

function buildMessage(message = '', detailedMessage = '', code = '') {
  const MAX_DETAIL_LENGTH = 100;
  const genericMessage = message || i18n.t('error:wrong'); // Messaggio generico

  const detailMessage = detailedMessage
    ? i18n.t('error:errordetailed', { detail: detailedMessage })
    : ''; // Dettaglio opzionale

  const truncatedDetail =
    detailMessage.length > MAX_DETAIL_LENGTH
      ? detailMessage.substring(0, MAX_DETAIL_LENGTH) + '...'
      : detailMessage.trim();

  const fullMessage = [genericMessage, truncatedDetail].filter(Boolean).join(' - ');

  return {
    code,
    message: fullMessage,
    name: 'Global Error',
    handled: false,
  };
}

let custError;
// Configurazione per catturare errori globali
function GlobalErrorHandler(showToast) {
  // Cattura errori non gestiti nei componenti React

  const handleError = (event) => {
    if (event.error instanceof CustomError) {
      if (event.error.handled) { return; } // Ignora errori già gestiti
      showToast(event.error.message, 'error');
      // Segna l'errore come gestito
      event.error.handled = true;
      return;
    } else if (event.error instanceof Error) {
      custError = new CustomError(buildMessage(undefined, event.error?.message, true));
      showToast(custError.message, 'error');
      return;
    } else if (event.error) {
      // Gestione errore non tipizzato o oggetto arbitrario
      const errorDescription =
        typeof event.error === "object" && event.error !== null
          ? JSON.stringify(event.error)
          : String(event.error || "Unknow Error");
      custError = new CustomError(buildMessage(undefined, errorDescription, true));
      showToast(custError.message, 'error');
      return;
    } else {
      // Gestione errore null/undefined
      custError = new CustomError(buildMessage(undefined, undefined, true));
      showToast(custError.message, 'error');
      return;
    }
  };

  const handleUnhandledRejection = (event) => {
    let err = event.error || event.reason;

    if (err instanceof CustomError) {
      if (err.handled) { return; } // Ignora errori già gestiti
      showToast(err.message, 'error');
      // Segna l'errore come gestito
      err.handled = true;
      return;
    } else if (err instanceof Error) {
      custError = new CustomError(buildMessage(undefined, err.message, true));
      showToast(custError.message, 'error');
      return;
    } else if (err) {
      // Gestione errore non tipizzato o oggetto arbitrario
      const errorDescription =
        typeof err === "object" && err !== null
          ? JSON.stringify(err)
          : String(err || "Unknow Error");
      custError = new CustomError(buildMessage(undefined, errorDescription, true));
      showToast(custError.message, 'error');
      return;
    } else {
      // Gestione errore null/undefined
      custError = new CustomError(buildMessage(undefined, undefined, true));
      showToast(custError.message, 'error');
      return;
    }
  }

  // Aggiungi i listener
  window.addEventListener('error', handleError);
  window.addEventListener('unhandledrejection', handleUnhandledRejection);
}

export default GlobalErrorHandler;